import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Protected route component that checks authentication status
 * If authenticated, renders the child routes
 * If not authenticated, redirects to the setup page
 */
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // If authenticated, render the child routes; otherwise redirect to setup
  return isAuthenticated ? <Outlet /> : <Navigate to="/setup" replace />;
};

export default ProtectedRoute;